import ProductSourceProductSourceSettings from '../product-source-settings';
import * as groupBy from 'lodash.groupby';
import { pick } from 'lodash';

export default {
  name: 'ProductSourceProductSource',
  props: ['productSources', 'translations', 'isSelectedProductSourceCalculated'],
  components: { ProductSourceProductSourceSettings },
  methods: {
    selectSource(display_id) {
      this.$emit('sourceSelected', display_id);
    },
    updateArguments(display_id, args) {
      this.$emit('argumentsChanged', display_id, args);
    }
  },
  computed: {
    productSourceGroups() {
      return pick(groupBy(this.productSources, 'display_group'), ['product_segment', 'product_catalog']);
    },
    selectedSource() {
      return this.productSources.find(productSource => productSource.selected) || {};
    },
    selectedGroup: {
      get() {
        return this.selectedSource.display_group;
      },
      set(group) {
        this.selectSource(this.productSourceGroups[group][0].display_id);
      }
    }
  }
};
